import { render, staticRenderFns } from "./MatrizUnidadesAdministrativasView.vue?vue&type=template&id=d091ba7e&"
import script from "./MatrizUnidadesAdministrativasView.vue?vue&type=script&lang=js&"
export * from "./MatrizUnidadesAdministrativasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports